import { call, restService } from './apiHelpers';

export const voterService = {
  ...restService('voters'),
  getForActor: (_, filters = {}) => call('get', 'voters/', null, {
    ...filters,
    coordinador_id: filters.coordinadorId,
    puntero_id: filters.punteroId,
  }),
  getFilterOptions: () => call('get', 'voters/filter-options/'),
  checkDuplicateDocument: (document) =>
    call('get', 'voters/check-duplicate/', null, { cedula: document }),
  createForActor: (payload) => call('post', 'voters/', payload),
  createFromPadron: (payload) => call('post', 'votantes/desde-padron/', payload),
  updateForActor: (id, payload) => call('patch', `voters/${id}/`, payload),
  getDetailForActor: (id) => call('get', `voters/${id}/`),
  getMyProfile: () => call('get', 'voters/my-profile/'),
  reassignLeader: (id, leaderId) =>
    call('patch', `voters/${id}/reasignar-puntero/`, { puntero_id: leaderId }),
  setMobileNeed: (id, value) =>
    call('patch', `voters/${id}/`, { needs_vehicle: value }),
  deactivate: (id) => call('patch', `voters/${id}/`, { status: 'INACTIVE' }),
  removeFromLeader: (id) => call('post', `voters/${id}/remove-from-leader/`, {}),
};
